import axios from "axios";

export default class Permission {
  constructor() {
    this.base_url = process.env.REACT_APP_URL_USER;
    this.name = "/permissions";
    this.url = this.base_url + this.name;
  }

  findAll = async () => {
    return await axios.get(`${this.url}`);
  };
}
